import axios from "./axios";

export default class ObservationService {
  static getStats() {
    return axios.get("Dashboard").then((response) => response.data);
  }
}
